import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const ABOUT_IMG =
  "https://images.pexels.com/photos/10344213/pexels-photo-10344213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const bullets = [
  "Domestic and commercial customers",
  "Qualified, vetted and insured engineers",
  "Quick response and on-time completion",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#0A192F] text-white py-20 md:py-32 pbs-grain relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="order-2 lg:order-1"
        >
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-white/40 rounded-md hidden md:block" />
            <img
              src={ABOUT_IMG}
              alt="Skilled tradesperson working on site"
              loading="lazy"
              className="relative rounded-md w-full h-[420px] lg:h-[520px] object-cover shadow-2xl"
            />
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-white/40 rounded-md hidden md:block" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="order-1 lg:order-2"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">
            About Perficient
          </span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight">
            Reliable building services, delivered properly.
          </h2>
          <p className="mt-6 text-white/80 leading-relaxed">
            {BUSINESS.name} provides dependable maintenance and building
            services for both domestic and commercial customers. We combine
            quality workmanship with professional service and quick response
            times — so problems get solved the first time, on time.
          </p>
          <p className="mt-4 text-white/80 leading-relaxed">
            Whether you need a single repair, a new installation, or ongoing
            maintenance across your property portfolio, our team handles it
            cleanly and communicates clearly from quote to completion.
          </p>

          <ul className="mt-8 space-y-3">
            {bullets.map((b) => (
              <li
                key={b}
                className="flex items-start gap-3 text-white font-medium"
              >
                <CheckCircle2
                  className="w-5 h-5 mt-0.5 text-white"
                  strokeWidth={1.8}
                />
                {b}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
